import calculatePrice from 'helpers/calculatePrice';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import Scrollbar from 'react-scrollbars-custom';
import PcModelAddToCart from '../PcModelAddToCart';
import styles from './styles';

const PcModelModal = ({
  pcModel,
  title,
  basePrice,
  options,
  isOpen,
  onClose,
  showCartButton,
  disabled,
  productType,
}) => {
  const price = calculatePrice(options, basePrice);
  return (
    <>
      <ReactModal
        isOpen={isOpen}
        onRequestClose={onClose}
        className="modal-content"
        overlayClassName="modal-overlay"
        shouldCloseOnOverlayClick
        shouldCloseOnEsc
        preventScroll
        style={{
          overlay: {
            background: 'rgba(255, 255, 255, 0.25)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 100,
          },
          content: {
            margin: '10px',
            borderRadius: '2px',
            minWidth: '50vw',
            overflow: 'hidden',
          },
        }}
      >
        <div className="modal-wrapper">
          <div className="modal-header">
            <div className="modal-header-title">{title}</div>

            <div className="modal-header-icon" onClick={onClose} />
          </div>

          <Scrollbar
            translateContentSizesToHolder
            style={{ maxHeight: '50vh', minWidth: '100%' }}
          >
            <div className="modal-body">
              <table>
                <tbody>
                  {options.map((option) => (
                    <tr key={option.group_type}>
                      <td className="group-type">
                        {!option.is_base && (
                          <em>{`* ${option.group_title}`}</em>
                        )}
                        {option.is_base && <span>{option.group_title}</span>}
                      </td>
                      <td className="component-name">
                        {!option.title && <em>- None -</em>}
                        {option.title && option.title}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Scrollbar>

          <div className="modal-footer">
            <div className="modal-footer-price">
              <div className="currency">MYR</div>
              <div className="price">
                RM {parseFloat(price).toLocaleString()}
              </div>
            </div>

            {showCartButton && (
              <div className="modal-footer-button">
                <PcModelAddToCart
                  pcModel={pcModel}
                  options={options}
                  disabled={disabled}
                  productType={productType}
                  customProductLink={global?.window?.location?.href}
                />
              </div>
            )}
          </div>
        </div>
      </ReactModal>

      <style jsx>{styles}</style>
    </>
  );
};

PcModelModal.propTypes = {
  title: PropTypes.string,
  basePrice: PropTypes.number.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      pc_model_uid: PropTypes.string.isRequired,
      pc_model_title: PropTypes.string.isRequired,
      group_type: PropTypes.string.isRequired,
      group_title: PropTypes.string.isRequired,
      group_step_new: PropTypes.string.isRequired,
      id: PropTypes.number,
      title: PropTypes.string,
      sku: PropTypes.string,
      is_base: PropTypes.bool.isRequired,
      variant_id: PropTypes.number,
    }).isRequired,
  ).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  showCartButton: PropTypes.bool,
  disabled: PropTypes.bool,
  productType: PropTypes.string,
};

PcModelModal.defaultProps = {
  title: 'Your Current Configuration',
  showCartButton: true,
  disabled: false,
  productType: null,
};

export default PcModelModal;
